import { createContext, useContext, useEffect, useState } from "react";
import { Sun, Moon } from "lucide-react";

const ThemeContext = createContext(null);
export const useTheme = () => useContext(ThemeContext);

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => localStorage.getItem("ic_theme") || "dark");

  useEffect(() => {
    const root = document.documentElement;
    root.setAttribute("data-theme", theme);
    if (theme === "dark") root.classList.add("dark");
    else root.classList.remove("dark");
    localStorage.setItem("ic_theme", theme);
  }, [theme]);

  const toggle = () => setTheme((t) => (t === "dark" ? "light" : "dark"));
  return <ThemeContext.Provider value={{ theme, toggle }}>{children}</ThemeContext.Provider>;
}

export function ThemeToggle({ className = "" }) {
  const { theme, toggle } = useTheme();
  return (
    <button onClick={toggle} data-testid="theme-toggle" title="Toggle light / dark"
      className={`relative w-9 h-9 rounded-lg grid place-items-center text-muted-foreground hover:text-[hsl(var(--gold))] hover:bg-secondary transition-colors ${className}`}>
      {theme === "dark" ? <Moon size={17} /> : <Sun size={17} />}
    </button>
  );
}
